import { useContext } from 'react';
import Legend from './Legend';
import { debugMode } from '../model/StaticVariables';
import { HoveredFeatureModal } from './FeatureModal';
import { HoveredFeatureTitle } from './FeatureTitle';
import MapContext from '../controller/MapProvider';
import RemoveMapMarkerButton from './RemoveMapMarkerButton';
import { checkAdjustShortScreens } from './checkAdjustShortScreens';
import MapController from '../controller/MapController';
import { FeatureProvider } from '../model/FeatureProvider';

const ContentMap = () => {
    const { map } = useContext(MapContext);
    checkAdjustShortScreens(map);

    return (
        <>
            <FeatureProvider>
                <HoveredFeatureModal />
                <HoveredFeatureTitle />
                <RemoveMapMarkerButton />

                {debugMode && <div id="viewPortBoundary"></div>}
                <MapController />
            </FeatureProvider>
            <Legend />
        </>
    );
};
export default ContentMap;
